module.exports = __webpack_public_path__ + "media/images/Apple_store_badge_135px-3a062739.png";